import { FieldProps } from "@rjsf/utils";
import { FormInput, FormSelect } from "@/components/Inputs/RJSFInputs";
import { IAlertDestProps } from "./FormGenerator.types";

const AlertDest = (props: FieldProps & IAlertDestProps) => {
  const {
    formData = {},
    onChange,
    schema,
    idSchema,
    slackChannels,
    telegramChannels,
    smsChannels,
    groupDestinationNames,
  } = props;

  const handleAlertDestTypeChange = (newValue: string) => {
    const newFormData = { ...formData, alert_dest_type: newValue, value: "" };
    onChange(newFormData);
  };

  const handleValueChange = (newValue: any) => {
    const newFormData = { ...formData, value: newValue };
    onChange(newFormData);
  };

  const getEnumOptions = (alertDestType: string) => {
    switch (alertDestType) {
      case "slack":
        return slackChannels;
      case "telegram":
        return telegramChannels;
      case "sms":
        return smsChannels;
      case "group":
        return groupDestinationNames;
      default:
        return [];
    }
  };

  const alertDestTypeEnumOptions =
    ((schema as any).properties.alert_dest_type as any).enum || [];

  const valueEnumOptions = getEnumOptions(formData.alert_dest_type);

  return (
    <div className="custom-alert-dest-item pulse-display-f">
      <FormSelect
        id={`${idSchema.$id}_alert_dest_type`}
        options={{
          enumOptions: alertDestTypeEnumOptions.map((option: string) => ({
            value: option === "dest_type" ? null : option,
            label: option === "dest_type" ? "Destination Type" : option,
          })),
        }}
        value={formData.alert_dest_type || ""}
        onChange={handleAlertDestTypeChange}
      />
      {formData.alert_dest_type && valueEnumOptions.length > 0 ? (
        <FormSelect
          id={`${idSchema.$id}_value`}
          options={{
            enumOptions: valueEnumOptions.map((option: string) => ({
              value: option,
              label: option,
            })),
          }}
          value={formData.value || ""}
          onChange={handleValueChange}
        />
      ) : (
        <FormInput
          id={`${idSchema.$id}_value`}
          value={formData.value || ""}
          onChange={handleValueChange}
          placeholder="Enter value"
        />
      )}
    </div>
  );
};

export default AlertDest;
